/**
 * The sentence the API sends, as a plain-string 404, when "view as" names a member of staff who does
 * not exist (#1659). The frontend recognises it to raise the view-as banner's warning, so every page —
 * not just the ones with their own error handling — tells the user why it is empty and how to get out.
 *
 * This is a COPY of `StaffResolutionResults.ImpersonationTargetNotFoundMessage` in the API.
 * `ImpersonationTargetNotFoundFrontendContractTests` reads this file and fails if the two differ, so
 * change them together. Keep it a single-quoted string on one line: that test reads it with a pattern.
 */
export const IMPERSONATION_TARGET_NOT_FOUND_MESSAGE =
  'The member of staff you are viewing as could not be found. They may have been removed. Use Stop impersonation to see your own data, or pick a different member of staff.';

/** Whether an error, as a handler or the interceptor receives it, is the "view-as target is gone" refusal. */
export function isImpersonationTargetNotFound(error: unknown): boolean {
  return error === IMPERSONATION_TARGET_NOT_FOUND_MESSAGE;
}
